export const DATES_FILTER = 'dates-filter-wrap';
export const TYPE_FILTER = 'filter_start_date';
